import { Grid } from "@mui/material";
import { FormField } from "@/components/elements/FormField";
import { Textarea } from "@/components/elements/Textarea";
import { InnerBox } from "@/components/elements/InnerBox";
import { useFormContext } from "react-hook-form";
import { TCompanyForm } from "@/features/company/types/CompanyForm";
import { FC } from "react";
import { CompanyFormTitle } from "@/features/company/components/company-info/CompanyFormTitle";

type TCompanyAdditionalInfoProps = {};
export const CompanyAdditionalInfo: FC<TCompanyAdditionalInfoProps> = () => {
  const methods = useFormContext<TCompanyForm>();

  const { control } = methods;
  return (
    <InnerBox title={<CompanyFormTitle text="その他の情報" />} showDivider={false}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <FormField control={control} name="companyDescription">
            <Textarea />
          </FormField>
        </Grid>
        <Grid item xs={12}>
          <FormField control={control} name="memo">
            <Textarea />
          </FormField>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
